import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import style from './login-form.module.css';
import messages from './messages';

const LOGIN_SYSTEM_ERROR_THRESHOLD = 3;

const SystemStatusBanner = ({ loginSystemErrorCount }) => {
  if (loginSystemErrorCount < LOGIN_SYSTEM_ERROR_THRESHOLD) {
    return null;
  }

  return (
    <div className={style['error-message']}>
      <FormattedMessage
        {...messages.systemDownMessage}
        values={{
          support: (chunks) => (
            <a href='mailto:support@shipstation.com' rel='noopener noreferrer' target='_blank'>
              {chunks}
            </a>
          ),
          status: (chunks) => (
            <a href='https://status.shipstation.com' rel='noopener noreferrer' target='_blank'>
              {chunks}
            </a>
          ),
        }}
      />
    </div>
  );
};

SystemStatusBanner.propTypes = {
  loginSystemErrorCount: PropTypes.number.isRequired,
};

export default SystemStatusBanner;
